import React, { Fragment, useState, useEffect } from 'react';
import {
  Container,
  Card,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from 'reactstrap';
import { useFormik } from 'formik';
import {
  CREATE_CUSTOMER_URL,
  SELECT_CUSTOMER_URL,
  EDIT_CUSTOMER_URL,
} from '../../../utils/APIEndpoints';
import { AGENCY_CUSTOMER_PAGE } from '../../../utils/AppRoutes';
import {
  getCurrentUserId,
  getCurrentAgencyId,
  getAlertToast,
} from '../../../utils/functions/CustomFunctions';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import Swal from 'sweetalert2';
import CustomLoader from '../../common/CustomLoader';
import { useHistory, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';

function NewCustomer(props) {
  const { id = 0 } = useParams();
  const history = useHistory();
  let location = useLocation();
  const [loading, setLoading] = useState(false);
  const [editFlow, setEditFlow] = useState('');
  let [initialValues, setInitialValues] = useState({
    customerName: '',
    email: '',
    phoneNumber: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    description: '',
  });

  const validationSchema = Yup.object({
    customerName: Yup.string().required('Name is required'),
    phoneNumber: Yup.number().required('phonenumber is required'),
    address: Yup.string().required('address is required'),
    city: Yup.string().required('city is required'),
    state: Yup.string().required('state is required'),
    zipCode: Yup.string().required('zip is required'),
    email: Yup.string()
      .trim()
      .required('Email is required')
      .email('Enter valid email'),
  });

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      createCustomer(values);
    },
  });

  const back = () => {
    history.push(AGENCY_CUSTOMER_PAGE);
  };

  //create Customer
  const createCustomer = async (values) => {
    values.createdBy = getCurrentUserId();
    values.agencyId = getCurrentAgencyId();
    try {
      setLoading(true);
      const options = {
        method: editFlow == 'edit' ? 'PUT' : 'POST',
        url: editFlow == 'edit' ? EDIT_CUSTOMER_URL : CREATE_CUSTOMER_URL,
        headers: authHeader(),
        data:
          editFlow == 'edit'
            ? {
                customerId: id,
                customerName: values.customerName,
                phoneNumber: values.phoneNumber,
                address: values.address,
                description: values.description,
                city: values.city,
                state: values.state,
                zipCode: values.zipCode,
              }
            : values,
      };
      const response = await API(options);
      
      const { status, message } = response.data;
      if (status === 'Success') {
        Swal.fire(getAlertToast('success', message));
        history.push(AGENCY_CUSTOMER_PAGE);

        resetForm();
      } else if (status === 'Error') {
        Swal.fire(getAlertToast('error', message));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //select Value
  const loadValues = async () => {
    try {
      // setLoading(true);
      const options = {
        method: 'GET',
        url: SELECT_CUSTOMER_URL,
        headers: authHeader(),
        params: { customerId: parseInt(id) },
      };
      const response = await API(options);

      const { status, data } = response.data;
      
      if (status === 'Success') {
       
        setInitialValues({
          customerName: data.customerName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          address: data.address,
          description: data.description,
          state: data.state,
          zipCode: data.zipCode,
          city: data.city,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadValues();
    }
  }, []);

  useEffect(() => {
    let currentMenuToActive = window.location.pathname.split('/')[2] || '/';
    setEditFlow(currentMenuToActive);
  }, [location]);


  return (
    <Fragment>
      <Container fluid className="mt-5">
        <Card body>
          <CardTitle tag="h6" className="item-center">
            New Customer
            <div className="invoice-BTn-l">
              <Button color="primary" onClick={back}>
                <i className="fas fa-arrow-left" /> Back
              </Button>
            </div>
          </CardTitle>

          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="customerName">Customer Name</Label>
              <Input
                type="text"
                name="customerName"
                id="customerName"
                onChange={handleChange}
                value={values.customerName}
                invalid={
                  errors.customerName && touched.customerName ? true : false
                }
                placeholder="Enter customerName"
              />
              <FormFeedback>
                {errors.customerName && touched.customerName
                  ? errors.customerName
                  : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="Enter Email"
                onChange={handleChange}
                invalid={errors.email && touched.email ? true : false}
                value={values.email}
              />
              <FormFeedback>
                {errors.email && touched.email ? errors.email : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="phoneNumber">Phone Number</Label>
              <Input
                type="number"
                name="phoneNumber"
                id="phoneNumber"
                onChange={handleChange}
                value={values.phoneNumber}
                placeholder="Enter PhoneNumber"
                invalid={
                  errors.phoneNumber && touched.phoneNumber ? true : false
                }
              />
              <FormFeedback>
                {errors.phoneNumber && touched.phoneNumber
                  ? errors.phoneNumber
                  : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="address">Address</Label>
              <Input
                type="textarea"
                name="address"
                id="address"
                onChange={handleChange}
                value={values.address}
                placeholder="Enter address"
                invalid={errors.address && touched.address ? true : false}
              />
              <FormFeedback>
                {errors.address && touched.address ? errors.address : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="email">City</Label>
              <Input
                type="text"
                name="city"
                id="city"
                placeholder="Enter city"
                onChange={handleChange}
                invalid={errors.city && touched.city ? true : false}
                value={values.city}
              />
              <FormFeedback>
                {errors.city && touched.city ? errors.city : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="email">State</Label>
              <Input
                type="text"
                name="state"
                id="state"
                placeholder="Enter state"
                onChange={handleChange}
                invalid={errors.state && touched.state ? true : false}
                value={values.state}
              />
              <FormFeedback>
                {errors.state && touched.state ? errors.state : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="zzipCodeip">Zip</Label>
              <Input
                type="text"
                name="zipCode"
                id="zipCode"
                placeholder="Enter zipCode"
                onChange={handleChange}
                invalid={errors.zipCode && touched.zipCode ? true : false}
                value={values.zipCode}
              />
              <FormFeedback>
                {errors.zipCode && touched.zipCode ? errors.zipCode : ''}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="description"
                onChange={handleChange}
                value={values.description}
                placeholder="Description"
              />
            </FormGroup>
            <Button type="submit">
              <CustomLoader loading={loading} />
              {editFlow === 'edit' ? 'Save' : 'Submit'}
            </Button>
          </Form>
        </Card>
      </Container>
    </Fragment>
  );
}

export default NewCustomer;
